//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "FLACC",
  data() {
    return {
      disabled: false,
      hasScore: false,
      form: {
        item1: '',
        item2: '',
        item3: '',
        item4: '',
        item5: '',
      },
      item1List: [
        { value: '0', name: '无特定表情或微笑' },
        { value: '1', name: '偶尔面部扭曲或皱眉' },
        { value: '2', name: '持续颤抖下巴，紧皱眉头' },
      ],
      item2List: [
        { value: '0', name: '正常体位或放松状态' },
        { value: '1', name: '不适，肌肉或神经紧张，肢体间断弯曲/伸展' },
        { value: '2', name: '踢或拉直腰，高张力，肢体扩大弯曲/伸展，发抖' },
      ],
      item3List: [
        { value: '0', name: '安静平躺，正常体位，可顺利移动' },
        { value: '1', name: '急促不安，来回移动，紧张，移动犹豫' },
        { value: '2', name: '卷曲或痉挛，来回摆动，头部左右摇动，揉搓身体某部分' },
      ],
      item4List: [
        { value: '0', name: '不哭不闹' },
        { value: '1', name: '呻吟或啜泣，偶尔哭泣，叹息' },
        { value: '2', name: '不断哭泣，尖叫或抽泣，呻吟' },
      ],
      item5List: [
        { value: '0', name: '平静，满足，放松，不要求安慰' },
        { value: '1', name: '可通过偶尔身体接触消除疑虑，分散注意' },
        { value: '2', name: '安慰有困难' },
      ],
    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result = form.item1 + form.item2 + form.item3 + form.item4 + form.item5
        self.hasScore = true;
        return String(result);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/FLACC.vue